import React, { memo, FunctionComponent } from 'react';
import { StyledLabel, ErrorMsg } from 'elements/FormControlLabel/style';

const FormControlLabel: FunctionComponent<any> = ({
  label,
  labelPlacement,
  control,
  error,
  id,
  fullWidth = true,
  props
}) => {
  return (
    <>
      <StyledLabel
        label={label}
        labelPlacement={labelPlacement}
        control={control}
        id={id}
        fullWidth={fullWidth}
        {...props}
      />
      {error && <ErrorMsg className='error-msg'>{error}</ErrorMsg> }
    </>
  );
};


export default memo(FormControlLabel);
